import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { take, takeUntil } from 'rxjs/operators';
import {Router} from '@angular/router';
import { IToastState } from '@shared/store/toast/toast-reducer';
import { select, Store } from '@ngrx/store';
import { getCurrentToast } from '@shared/store/toast/toast-selectors';
import { Subject } from 'rxjs';
import { DismissToastSuccessAction } from '@shared/store/toast/toast-actions';
import { EventStatus } from '@shared/models/notification-message.model';

@Injectable({
  providedIn: 'root',
})

export class GtcPlanningScenarioCommandHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  unsubscribe$ = new Subject<void>();
  planningId : any;
  lastToastNotificationId : any;
  eatFlowNodeNotificationType : any;
  isSubscribed: boolean;
  constructor(private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router,
              private toastStore: Store<IToastState>,) {
      this.isSubscribed = false;

  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['DialogDefinition']) {
      delete command.fieldValues['DialogDefinition'];
    }
    this.executeCommandToApi(command);
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        console.log('Command Response', commandResponse);
        if(commandResponse.status == EventStatus.Pending){
          return;
        }
        this.fuseSplashScreenService.hide();
        if (commandResponse.fieldValues['RedirectCommand']) {
          this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
          return;
        }
        if (commandResponse.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
        }
        else if (commandResponse.fieldValues['PlatformLinkModel']) {
          this.invalidateSubject.invalidate('Refresh');
        }
        this.invalidateSubject.invalidate();
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('command failed!!!', error);
      });
    }
  }

  onBeforeLoad() {
    if(this.isSubscribed) return ;
    this.isSubscribed = true;
    this.planningId = this.magicLinkModel?.fieldValues['PlanningId'];
    if(this.planningId){
     this.eatFlowNodeNotificationType = this.planningId + "-EatToastNotification";
    }
    else{
     this.eatFlowNodeNotificationType = "";
    }
      this.toastStore.select(getCurrentToast).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
        if (res && res.type === this.eatFlowNodeNotificationType) {
          //TODO : need to find why this call is coming multiple times : Foysal
          // Target : Unicorn branch
          // Now i am using lastToastNotificationId to restrict multiple calls for single notification
          if (res.commands && res.commands.length > 0 && res.id && this.lastToastNotificationId != res.id) {
            this.lastToastNotificationId = res.id;
            this.fuseSplashScreenService.show();
            this.executeCommandToApi(res.commands[0]);

          }
          this.toastStore.dispatch(new DismissToastSuccessAction(res));

        }
      });
    }
  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged(event) {
    if (this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`]) {
      const command = this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`];
      command.fieldValues['ItemId'] = event.item.id;
      command.fieldValues['FieldKey'] = event.fieldDefinition.key;
      switch (event.fieldDefinition.key) {
        case 'Name':
          command.fieldValues['ScenarioId'] = event.item.cells['Name'].value;
          break;
        case 'BaseScenario':
          command.fieldValues['ScenarioId'] = event.item.cells['BaseScenario'].value;
          break;
      }
      this.executeCommand(command);
    } else if (event.action) {
      if (this.magicLinkModel.additionalCommands[`${event.action.id}PlanningActionCommand`]) {
        const command = this.magicLinkModel.additionalCommands[`${event.action.id}PlanningActionCommand`];
        command.fieldValues['ItemId'] = event.item.id;
        this.executeCommand(command);
      }
    }
  }

  destroy(): void {
    this.isSubscribed = false;
    this.lastToastNotificationId = null;
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
